import type { Location } from '#/graphql/types';
import { gql } from '@apollo/client';
import { getLocation, getLocationList } from '#/graphql/queries';
import { inUseStatuses } from './constants';
import FieldDefs from '#/types/FieldDefs';
import { getBaseColumns } from '#/common/utils/baseColumns';
import { levels } from '../components/Location.Mappings';

const fields = {
  ...getBaseColumns(),
  id: {
    dataField: 'id',
    label: 'ID',
    editorType: 'TextBox',
    editorOptions: { readOnly: true },
    isRequired: true,
  },
  name: {
    dataField: 'name',
    label: 'Name',
    isRequired: true,
    editorType: 'TextBox',
  },
  notes: {
    dataField: 'notes',
    label: 'Notes',
    editorType: 'TextArea',
  },
  lat: {
    dataField: 'lat',
    label: 'Latitude',
    editorType: 'NumberBox',
    editorOptions: {
      placeholder: 'Enter a latitude',
      min: -90,
      max: 90,
      step: 1,
      format: '#0.######',
      showSpinButtons: true,
    },
  },
  lng: {
    dataField: 'lng',
    label: 'Longitude',
    editorType: 'NumberBox',
    editorOptions: {
      placeholder: 'Enter a longitude',
      min: -180,
      max: 180,
      step: 1,
      format: '#0.######',
      showSpinButtons: true,
    },
  },
  address: {
    dataField: 'address',
    label: 'Address',
    editorType: 'TextArea',
  },
  parentId: {
    dataField: 'parentId',
    label: 'Parent',
    isRequired: true,
    editorType: 'RelatedItems',
    editorOptions: {
      button: {
        tooltip: 'View location details',
        url: '/assets/locations/:value/details',
        desktopOnly: false,
      },
      displayExpr: 'name',
      valueExpr: 'id',
      disabled: true,
      dataStoreOptions: {
        filter: ['inUseStatus', '=', inUseStatuses.inUse.key],
        getItem: gql(getLocation),
        getItemList: gql(getLocationList),
      },
    },
  },
  level: {
    dataField: 'level',
    label: 'Type',
    editorType: 'Lookup',
    isRequired: true,
    editorOptions: {
      displayExpr: 'label',
      valueExpr: 'key',
      searchEnabled: false,
      dataSource: Object.values(levels),
    },
  },
  inUseStatus: {
    dataField: 'inUseStatus',
    label: 'In-use Status',
    editorType: 'Lookup',
    editorOptions: {
      displayExpr: 'label',
      valueExpr: 'key',
      searchEnabled: false,
      dataSource: Object.values(inUseStatuses),
    },
  },
  thirdPartyId: {
    dataField: 'thirdPartyId',
    label: 'Third Party ID',
    editorType: 'TextBox',
  },
  source: {
    dataField: 'source',
    label: 'Third Party Source',
    editorType: 'TextBox',
  },
} satisfies FieldDefs<Location>;

export default fields;
